import React, { useState } from "react";
import { array, string, number } from "prop-types";

import CollectionNameTabs from "../../../molecules/CollectionNameTabs";
import NumberedStoryHeadline from "../../../molecules/NumberedStoryHeadline";

import "./organism1.m.css";

const Organism1 = ({
  subCollections,
  lang,
  mostCommentedStoriesList,
  mostCommentedTitle,
  mostCommentedPosition,
  storiesToLoadInRemainingCollections,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onTabClick = (selectedTabIndex) => setSelectedIndex(selectedTabIndex);
  const subCollectionNames = subCollections.map((item) => item.name);
  mostCommentedPosition > 1 && subCollectionNames.splice(mostCommentedPosition - 2, 0, mostCommentedTitle);

  const SubCollectionStories = subCollections.map((subCollection) =>
    subCollection.items.filter((item) => item.type === "story")
  );
  mostCommentedPosition > 1 &&
    SubCollectionStories.splice(mostCommentedPosition - 2, 0, mostCommentedStoriesList || []);

  return (
    <div styleName={`base`}>
      <CollectionNameTabs
        collectionList={subCollectionNames.slice(0, 3)}
        selectedIndex={selectedIndex}
        onTabClick={onTabClick}
      />
      <NumberedStoryHeadline
        storyList={SubCollectionStories[selectedIndex].slice(0, storiesToLoadInRemainingCollections)}
        className="numbered-story-headline"
        lang={lang}
      />
    </div>
  );
};

Organism1.propTypes = {
  subCollections: array.isRequired,
  lang: string,
  mostCommentedStoriesList: array,
  mostCommentedTitle: string,
  mostCommentedPosition: number,
  storiesToLoadInRemainingCollections: number,
};

export default Organism1;
